import timeTrackingHelpers from './helpersShared';
import timeTrackingModel from '$$timeTrackingModel';

export default {
  setData(state, payload) {
    if (Array.isArray(payload)) {
      payload.forEach(timeTrackingHelpers.prepareLogsData);
    } else {
      timeTrackingHelpers.prepareLogsData(payload);
    }
    timeTrackingModel.parse(payload);
  },

};
